"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DefaultTraceFormatter: function() {
        return DefaultTraceFormatter;
    },
    ChromeTraceFormatter: function() {
        return ChromeTraceFormatter;
    },
    GetTraceFormatter: function() {
        return GetTraceFormatter;
    }
});
const _query = require("../../../infra-sk/modules/query");
const _json = require("../json");
const _paramtools = require("../paramtools");
require("../window/window");
const STATISTIC_SUFFIX_TO_VALUE_MAP = new Map([
    [
        'avg',
        'value'
    ],
    [
        'count',
        'count'
    ],
    [
        'max',
        'max'
    ],
    [
        'min',
        'min'
    ],
    [
        'std',
        'error'
    ],
    [
        'sum',
        'sum'
    ]
]);
function parseCommaSeparatedParamSet(trace) {
    const paramSet = {};
    const parts = trace.split(',');
    parts.forEach((part)=>{
        if (!part) return;
        const idx = part.indexOf('=');
        if (idx !== -1) {
            const k = part.substring(0, idx);
            const v = part.substring(idx + 1);
            paramSet[k] = [
                v
            ];
        }
    });
    return (0, _json.ParamSet)(paramSet);
}
let DefaultTraceFormatter = class DefaultTraceFormatter {
    formatTrace(params) {
        return `Trace ID: ${(0, _paramtools.makeKey)(params)}`;
    }
    formatQuery(trace) {
        if (trace.startsWith(',') || trace.includes('=')) {
            return (0, _query.fromParamSet)(this.formatParamSet(trace));
        }
        return '';
    }
    formatParamSet(trace) {
        if (trace.startsWith(',') || trace.includes('=')) {
            return parseCommaSeparatedParamSet(trace);
        }
        return (0, _json.ParamSet)((0, _query.toParamSet)(this.formatQuery(trace)));
    }
};
let ChromeTraceFormatter = class ChromeTraceFormatter {
    // formatTrace formats the param set in the form
    // master/bot/benchmark/test/subtest_1/subtest_2/subtest_3
    formatTrace(params) {
        const resultParts = [];
        for (const key of this.keys){
            if (key in params) {
                resultParts.push(params[key]);
            }
        }
        return resultParts.join('/');
    }
    // formatQuery converts a trace string to a query string.
    // The trace string is split by '/' and the values are assigned to the keys
    // defined in the keys array. Each key-value pair is then converted to a
    // query parameter in the format "key=value".
    formatQuery(trace) {
        if (trace.startsWith(',') || trace.includes('=')) {
            return (0, _query.fromParamSet)(this.formatParamSet(trace));
        }
        const parts = trace.split('/');
        const paramSet = (0, _json.ParamSet)({});
        for(let i = 0; i < parts.length; i++){
            if (i < this.keys.length) {
                paramSet[this.keys[i]] = [
                    parts[i]
                ];
            }
        }
        // We are using Chromeperf's test path to generate a query for Skia traces.
        // If default stat value is removed from the query, we should add the stat value in
        // paramset to avoid loading 6x traces. E.g., when the trace's 'test' value has no
        // stat suffix, it will have six 'stat' values. Those 'stat' values will be used in
        // the future Skia. But in the context of Chromeperf, it means the average, and thus
        // we should add the 'stat' value for trace query.
        // This ad hoc logic is specific to the Chromeperf style test_path used in
        // Chromeperf anomalies. It is no longer needed when Chromeperf is deprecated.
        if (window.perf.enable_skia_bridge_aggregation) {
            const testValue = paramSet['test'][0];
            const testParts = testValue.split('_');
            const suffix = testParts.pop();
            if (suffix !== undefined) {
                if (STATISTIC_SUFFIX_TO_VALUE_MAP.has(suffix)) {
                    // use the suffix to decide the stat value, and use the trimmed test name.
                    paramSet['test'] = [
                        testParts.join('_')
                    ];
                    paramSet['stat'] = [
                        STATISTIC_SUFFIX_TO_VALUE_MAP.get(suffix)
                    ];
                } else {
                    // apply the default stat value.
                    paramSet['stat'] = [
                        'value'
                    ];
                }
            }
        }
        return (0, _query.fromParamSet)(paramSet);
    }
    formatParamSet(trace) {
        if (trace.startsWith(',') || trace.includes('=')) {
            return parseCommaSeparatedParamSet(trace);
        }
        return (0, _json.ParamSet)((0, _query.toParamSet)(this.formatQuery(trace)));
    }
    constructor(){
        // TODO(eduardoyap): Remove hardcodings and implement more flexible format.
        this.keys = [
            'master',
            'bot',
            'benchmark',
            'test',
            'subtest_1',
            'subtest_2',
            'subtest_3',
            'subtest_4'
        ];
    }
};
// traceFormatterRecords specifies TraceFormat to TraceFormatter mapping records
const traceFormatterRecords = {
    '': new DefaultTraceFormatter(),
    chrome: new ChromeTraceFormatter()
};
function GetTraceFormatter() {
    return traceFormatterRecords[window.perf.trace_format];
}
